<div class="page-wide">
  <div class="page-intro  mb-3">
    <div class="d-flex flex-sm-row flex-column  justify-content-between mx-auto">
      <div class="p-3">
        <p class="custom-text fw-medium fs-1">By Owners, For Owners</p>
        <p class="custom-text fw-normal fs-3">
          From a top 10 Global Hotel Franchise
        </p>
        <p class="custom-text fw-normal fs-6 mt-4 lh-lg">
          As owners ourselves, we understand the challenges and needs that come
          with operating a successful property and we will provide you with the
          tools necessary to help you maximize your hotel’s performance
        </p>
        <p class="custom-text fw-normal fs-6 mt-4 lh-lg">
          Since its founding, Sonesta has built, owned, managed and designed
          hotels throughout the world. Our direction has remained the same: to
          provide our guests an authentic quality experience and treat all who
          walk through our doors with integrity
        </p>
      </div>
      <div class="p-3 text-center">
        <img
          src="../../../../assets/images/brand/FairBridgeInnSuites_logo.webp"
        />
      </div>
    </div>
    <h1
      class="fw-bold text-uppercase text-shadow align-self-end  text-center"
      style="color: rgba(255, 255, 255, 0.7)"
    >
      fairbridgeinns benefits
    </h1>
  </div>
  <section class="pt-4">
    <div class="fs-1 fw-medium custom-text">
      Why become FairBridgeInns franchisee?
    </div>
    <ul
      ngbNav
      #nav="ngbNav"
      [(activeId)]="active"
      class="nav-tabs mb-md-5 mt-2 border-bottom border-1 border-slate-blue fw-semibold fw-sm-bold"
    >
      <li ngbNavItem="explosive growth and momentum" >
        <button ngbNavLink class="text-uppercase w-100">
          explosive growth and momentum
        </button>
        <ng-template ngbNavContent>
          <div class="d-flex flex-sm-row flex-column justify-content-between">
            <div class="text-center">
              <img src="../../../../assets/images/brand/LoyaltyInn_logo.webp" />
            </div>
            <div class="p-sm-5 pt-5 w-50 w-sm-100">
              <div class="mb-3 fs-2 fw-semibold custom-text">
                Explosive growth and momentum
              </div>
              <p class="align-self-center  custom-text lh-base fs-5">
                Sed commodo, leo at suscipit dictum, quam est porttitor sapien,
                eget sodales nibh elit id diam. Nulla facilisi. Donec egestas
                ligula vitae odio interdum aliquet. Duis lectus turpis, luctus
                eget tincidunt eu, congue et odio. Lorem ipsum dolor sit amet
                consectetur, adipisicing elit. Debitis facere est et voluptatem
                nam perspiciatis labore, molestiae reiciendis quia, explicabo
                similique?Lorem, ipsum dolor sit amet consectetur adipisicing
                elit. Odio, similique doloribus, sint, blanditiis reprehenderit
                sunt aliquam commodi doloremque molestiae neque vero?
              </p>
            </div>
          </div>
        </ng-template>
      </li>
      <li ngbNavItem="powerful distinct brand">
        <button ngbNavLink class="text-uppercase w-100">
          powerful distinct brand
        </button>
        <ng-template ngbNavContent>
          <div class="d-flex flex-sm-row flex-column justify-content-between">
            <div class="text-center">
              <img src="../../../../assets/images/brand/LoyaltyInn_logo.webp" />
            </div>
            <div class="p-sm-5 pt-5 w-50 w-sm-100">
              <div class="mb-3 fs-2 fw-semibold custom-text w-100">
                Powerful distinct brand
              </div>
              <p class="align-self-center w-sm-75  lh-base fs-5">
                Sed commodo, leo at suscipit dictum, quam est porttitor sapien,
                eget sodales nibh elit id diam. Nulla facilisi. Donec egestas
                ligula vitae odio interdum aliquet. Duis lectus turpis, luctus
                eget tincidunt eu, congue et odio. Lorem ipsum dolor sit amet
                consectetur, adipisicing elit. Debitis facere est et voluptatem
                nam perspiciatis labore, molestiae reiciendis quia, explicabo
                similique?Lorem, ipsum dolor sit amet consectetur adipisicing
                elit. Odio, similique doloribus, sint, blanditiis reprehenderit
                sunt aliquam commodi doloremque molestiae neque vero?
              </p>
            </div>
          </div>
        </ng-template>
      </li>
      <li ngbNavItem="owners come first">
        <button ngbNavLink class="text-uppercase w-100">
          owners come first
        </button>
        <ng-template ngbNavContent>
          <div class="d-flex flex-sm-row flex-column justify-content-between">
            <div class="text-center">
              <img src="../../../../assets/images/brand/LoyaltyInn_logo.webp" />
            </div>
            <div class="p-sm-5 pt-5 w-50 w-sm-100">
              <div class="mb-3 fs-2 fw-semibold custom-text">
                Owners come first
              </div>
              <p class="align-self-center w-sm-75  lh-base fs-5">
                Sed commodo, leo at suscipit dictum, quam est porttitor sapien,
                eget sodales nibh elit id diam. Nulla facilisi. Donec egestas
                ligula vitae odio interdum aliquet. Duis lectus turpis, luctus
                eget tincidunt eu, congue et odio. Lorem ipsum dolor sit amet
                consectetur, adipisicing elit. Debitis facere est et voluptatem
                nam perspiciatis labore, molestiae reiciendis quia, explicabo
                similique?Lorem, ipsum dolor sit amet consectetur adipisicing
                elit. Odio, similique doloribus, sint, blanditiis reprehenderit
                sunt aliquam commodi doloremque molestiae neque vero?
              </p>
            </div>
          </div>
        </ng-template>
      </li>
      <li ngbNavItem="solid growth strategy">
        <button ngbNavLink class="text-uppercase  w-100">
          solid growth strategy
        </button>
        <ng-template ngbNavContent>
          <div class="d-flex flex-sm-row flex-column justify-content-between">
            <div class="text-center">
              <img src="../../../../assets/images/brand/LoyaltyInn_logo.webp" />
            </div>
            <div class="p-sm-5 pt-5 w-50 w-sm-100">
              <div class="mb-3 fs-2 fw-semibold custom-text">
                Solid growth strategy
              </div>
              <p class="align-self-center w-sm-75  lh-base fs-5">
                Sed commodo, leo at suscipit dictum, quam est porttitor sapien,
                eget sodales nibh elit id diam. Nulla facilisi. Donec egestas
                ligula vitae odio interdum aliquet. Duis lectus turpis, luctus
                eget tincidunt eu, congue et odio. Lorem ipsum dolor sit amet
                consectetur, adipisicing elit. Debitis facere est et voluptatem
                nam perspiciatis labore, molestiae reiciendis quia, explicabo
                similique?Lorem, ipsum dolor sit amet consectetur adipisicing
                elit. Odio, similique doloribus, sint, blanditiis reprehenderit
                sunt aliquam commodi doloremque molestiae neque vero?
              </p>
            </div>
          </div>
        </ng-template>
      </li>
    </ul>
    <div [ngbNavOutlet]="nav" class="mt-2"></div>
  </section>
  <section class="mt-4">
    <div class="banner-wrapper">
      <div>
        <h2 class="fs-1 fw-light">Ready To Join The FairbridgeInns Family?</h2>
      </div>
      <div class="pt-4">
        <button (click)="handleTouchPoint()">
          Get in Touch
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-arrow-right"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M10.828 8l-3.657 3.657.708.708L12.243 8l-4.364-4.364-.708.707L10.828 8z"
            />
          </svg>
        </button>
      </div>
    </div>
  </section>
</div>

